import { OrderTransport } from "src/app/transports/order";
import ReviewedGrid from "./ReviewedGrid";
import { allValuesAsync } from "./ReviewedHelps";

const ReviewedGridBlog = () => {
    return (
        <ReviewedGrid
            valuesAsync={allValuesAsync.blog}
            totalRowsHandle={OrderTransport.reviewed.blog.findTotal}
            listHandler={OrderTransport.reviewed.blog.list}
            totalFilteredHandle={OrderTransport.reviewed.blog.findTotalFiltered}
            exportHandler={OrderTransport.reviewed.blog.export}
        />
    );
};

export default ReviewedGridBlog;
